import { c as clsx } from './clsx-1afe6a70.js';
import { h } from './index-d3a9c8bd.js';
import { A as ARIA } from './constants-93a27459.js';

const InternalNesLabel = ({ nesId, label, legend, helpText, hiddenLabel, required, nesOptionalLabel = true, tooltip, eventDataTooltip, language, }) => (h("div", { lang: language },
    h("div", { class: clsx({
            'nes-mb-1': !helpText,
            'nes-sr-only': hiddenLabel,
        }) },
        h("div", { class: "nes-label" },
            label && (h("label", { class: "nes-label__label", htmlFor: nesId }, label)),
            legend && (h("legend", { class: "nes-label__label nes-label__label--legend", slot: "legend" }, legend)),
            h("span", { class: "nes-whitespace-nowrap" },
                tooltip && (h("nes-tooltip", { eventData: eventDataTooltip, class: "nes-label__tooltip", "data-nes-tooltip": true, nesId: nesId ? nesId + ARIA.tooltip : '', innerHTML: tooltip })),
                !required && (h("internal-nes-optional-label", { class: clsx('nes-label__optional', {
                        'nes-label__optional--tooltip': tooltip,
                        'nes-sr-only': !nesOptionalLabel,
                    }), id: nesId ? nesId + ARIA.optional : '' }))),
            legend && h("div", { class: "nes-label__clearfix" }))),
    helpText && (h("nes-help-text", { class: "nes-mb-2", id: nesId ? nesId + ARIA.helpText : '' }, helpText))));

export { InternalNesLabel as I };
